const LinkButton = ({href,title}) => (
    <a href={href} className="bg-sky-500 hover:bg-sky-400 text-grey-darkest font-bold py-1 px-2  inline-flex items-center text-white">{title}</a>
) 

export default LinkButton;